import DeleteAssignmentSchedule from './DeleteAssignmentSchedule';

export default DeleteAssignmentSchedule;
